var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.audio, function (item, index) {
      return _c("div", { key: index, staticClass: "audioBox" }, [
        _c("audio", {
          attrs: {
            controlslist: "nodownload noremoteplayback",
            controls: "",
            src: item.url.startsWith("http") ? item.url : `https://${item.url}`,
          },
        }),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/resource/audioResource.vue?vue&type=template&id=4f026653&scoped=true&
// module id = null
// module chunks = 